export enum ColumnTypeEnum {
  String = 1,
  Number,
  Boolean,
  Date,
  Time
}
